(function ($) {

    var SHOW = 5;

    function setupDots(gallery, paginationEl, total) {
        var $pg = $(paginationEl);
        var half = Math.floor(SHOW / 2);

        function dot(idx, distance) {
            var cls = 'hotel-dot';
            if (distance === 0) { cls += ' is-active'; }
            else if (distance === 1) { cls += ' hotel-dot--d1'; }
            else { cls += ' hotel-dot--d2'; }
            return '<span class="' + cls + '" data-index="' + idx + '"></span>';
        }

        function render() {
            var active = gallery.realIndex;
            var html = '';
            if (total <= SHOW) {
                for (var i = 0; i < total; i++) {
                    html += dot(i, Math.abs(i - active));
                }
            } else {
                for (var o = -half; o <= half; o++) {
                    var idx = ((active + o) % total + total) % total;
                    html += dot(idx, Math.abs(o));
                }
            }
            $pg.html(html);
        }

        render();
        gallery.on('slideChange', render);

        $pg.on('click', '.hotel-dot', function () {
            var index = parseInt($(this).attr('data-index'), 10);
            if (gallery.params.loop) {
                gallery.slideToLoop(index);
            } else {
                gallery.slideTo(index);
            }
        });
    }

    function whenImageReady(img, cb) {
        var done = false;
        function fin() { if (!done) { done = true; cb(); } }
        if (!img || img.complete) { fin(); return; }
        img.addEventListener('load', fin);
        img.addEventListener('error', fin);
        setTimeout(fin, 8000);
    }

    function initHotelImage(root) {
        $(root || document).find('.js-hotel-carousel').each(function () {
            var mainEl = this;
            var $main = $(mainEl);

            if (mainEl.swiper) {
                mainEl.swiper.update();
                $main.addClass('is-ready');
                return;
            }

            var total = $main.find('.swiper-slide').length;
            var multiple = total > 1;
            var firstImg = $main.find('.swiper-slide img').get(0);

            try {
                if (typeof Swiper === 'undefined') {
                    throw new Error('Swiper library is not loaded');
                }
                var gallery = new Swiper(mainEl, {
                    loop: multiple,
                    speed: 450,
                    spaceBetween: 10,
                    allowTouchMove: multiple,
                    navigation: {
                        prevEl: $main.find('.component-slider__button--prev').get(0),
                        nextEl: $main.find('.component-slider__button--next').get(0)
                    }
                });

                var paginationEl = $main.find('.component-slider__pagination').get(0);
                if (multiple && paginationEl) {
                    setupDots(gallery, paginationEl, total);
                }
                if (!multiple) {
                    $main.find('.component-slider__button, .component-slider__pagination').hide();
                }
            } catch (e) {
                if (window.console) { console.error(e); }
            }

            whenImageReady(firstImg, function () {
                $main.addClass('is-ready');
                if (mainEl.swiper) { mainEl.swiper.update(); }
            });
        });
    }

    function toggleDescription(show) {
        var $truncated = $(".description");
        var $full = $(".full-description");
        var $showLink = $(".description-show");
        var $hideLink = $(".description-hide");

        if (show) {
            $truncated.addClass("d-none");
            $full.removeClass("d-none");
            $showLink.addClass("d-none");
            $hideLink.removeClass("d-none");
        } else {
            $truncated.removeClass("d-none");
            $full.addClass("d-none");
            $showLink.removeClass("d-none");
            $hideLink.addClass("d-none");
        }
    }
    
    function initPropertyInfo(root) {
        initHotelImage(root);

        $(".description-show").off("click").on("click", function (e) {
            e.preventDefault();
            toggleDescription(true);
        });

        $(".description-hide").off("click").on("click", function (e) {
            e.preventDefault();
            toggleDescription(false);
        });
    }

    
    $(function () { initPropertyInfo(); });

    window.initPropertyInfo = initPropertyInfo;

})(jQuery);
